import React from 'react'
import propTypes from 'prop-types'
import map from 'lodash/map'
import get from 'lodash/get'
import find from 'lodash/find'

import { Spotlight } from '../../../Spotlight'
import { R } from '../../../../utils/currency'

export const Legend = ({ metasets, onHide, cursorDatapoints }) => {
  return (
    <section className='chart-legend'>
      {map(metasets, (metaset) =>
        <LegendItem
          key={metaset.index}
          onHide={onHide}
          datasetIndex={metaset.index}
          metaset={metaset}
          cursorDatapoints={cursorDatapoints}
        />
      )}
    </section>
  )
}

Legend.propTypes = {
  metasets: propTypes.arrayOf(propTypes.object).isRequired,
  datasetIndex: propTypes.number,
  onHide: propTypes.func,
  cursorDatapoints: propTypes.arrayOf(propTypes.object).isRequired
}

Legend.defaultProps = {
  cursorDatapoints: []
}

// There is alot of ceremony to construct the legend item.
// All of the data to construct the legend is found in the
// dataset.
// If there are no cursorDatapoints, then the legend defaults to the
// retirementAge, which can also be found on the dataset.
const LegendItem = ({ metaset, datasetIndex, onHide, cursorDatapoints }) => {
  const dataset = get(metaset, '_dataset')
  const subtextKey = get(dataset, 'subtextKey')
  const tickType = get(dataset, 'tickType', 'age')

  // Try to get an index from cursorDatapoints. If there isn't any
  // we default to the index that contains { age: retirementAge }
  const cursorDatapoint = find(cursorDatapoints, { datasetIndex: datasetIndex })
  let value = ''
  let tickValue = ''
  let subTickValue = null

  if (cursorDatapoint) {
    value = get(cursorDatapoint, 'element.$context.parsed.y')
    tickValue = get(cursorDatapoint, `element.$context.raw.${tickType}`)
    subTickValue = subtextKey ? get(cursorDatapoint, `element.$context.raw.${subtextKey}`) : null
  } else {
    const defaultIndex = get(dataset, 'defaultIndex')
    const defaultDatapoint = get(metaset, `data[${defaultIndex}].$context`)
    value = get(defaultDatapoint, 'element.$context.parsed.y')
    tickValue = get(defaultDatapoint, `element.$context.raw.${tickType}`)
    subTickValue = subtextKey ? get(defaultDatapoint, `element.$context.raw.${subtextKey}`) : null
  }

  const datasetLabel = get(dataset, 'label')
  const preposition = tickType === 'year' ? 'in' : 'at'
  const borderDash = get(dataset, 'borderDash')

  const color = get(dataset, 'borderColor')

  return (
    <Spotlight
      bold
      interactive
      onClick={(active) => {
        onHide(active, datasetIndex)
      }}
      color={color}
      subtext={subtextKey && `${R(subTickValue).format()} tax`}
      dashed={!!borderDash}
      className={`legend__item`}
      value={R(value).format()}
      description={`${datasetLabel} ${preposition} ${tickValue}`}
    />
  )
}
